import {
    getAllSponsorAdvertisementRequest, getSponsorAdvertisementByIdRequest
} from "../repositories/sponsor_advertisement_repository";

export const SponsorAdvertisementService = () => {
    const fetchAllSponsorAdvertisement = async (setSponsorAdvertisementList) => {
        try {
            const response = await getAllSponsorAdvertisementRequest();
            if (response?.success) {
                setSponsorAdvertisementList(response.data);
            } else {
                console.error("Failed to fetch sponsor advertisement : ", response?.errors);
            }
        } catch (error) {
            console.error("Failed to fetch sponsor advertisement data : ", error);
        }
    };

    const fetchSponsorAdvertisementById = async (id) => {
        try {
            const response = await getSponsorAdvertisementByIdRequest(id);
            if (response?.success) {
                return response.data;
            } else {
                console.error("Failed to fetch sponsor advertisementt detaills : ", response?.errors);
            }
        } catch (error) {
            console.error("Error in fetch sponsor advertisement by id : ", error);
        }
    };
    return {
        fetchAllSponsorAdvertisement,
        fetchSponsorAdvertisementById,
    }
}